// Mounted once at the App root. On first render captures UTM + landing page
// attribution into sessionStorage; on every route change fires a GA4 page_view
// with the resolved page_category so we can build "top landing page" reports
// downstream.

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureAttribution, trackEvent, categorizePath } from "../lib/analytics";

export default function AnalyticsListener() {
    const location = useLocation();

    // First-touch capture (idempotent — only runs on initial session pageview).
    useEffect(() => {
        captureAttribution(location);
        // We intentionally want this to fire only on mount.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Per-route page_view with attribution.
    useEffect(() => {
        const cat = categorizePath(location.pathname);
        trackEvent("page_view", {
            page_location: typeof window !== "undefined" ? window.location.href : "",
            page_path: location.pathname,
            page_category: cat.page_category,
            page_city: cat.city,
            page_state: cat.state,
        });
    }, [location.pathname]);

    return null;
}
